import React, { useEffect, useState, useMemo } from "react";
import { Link, graphql, useStaticQuery } from "gatsby";
import styled, { css } from "styled-components";
import { useLocation } from "@reach/router";
import "../styles/custom.css";

const WrapperNavbar = styled.div`
  margin-top: 20px;

  @media screen and (max-width: 1200px) {
    /* padding: 20px; */
    margin-top: 10px;
  }

  > div {
    height: 175px;
    background: #e8e8e0 0% 0% no-repeat padding-box;
    box-shadow: -5px -5px 10px #ffffff, 0px 0px 10px -5px #000000;
    opacity: 1;
    border-radius: 30px;
    padding: 10px;

    @media screen and (max-width: 1200px) {
      height: 160px;
      padding: 20px;
    }

    @media screen and (max-width: 640px) {
      height: 75px;
      padding: 10px;
      margin-top: -15px;
    }
  }
`;

const MenuList = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 75px;
  background: ${(props) => props.theme.background};
  border-radius: 50px;
  opacity: 1;
  /* padding: 0px 10px; */
  position: relative;

  @media screen and (max-width: 1200px) {
    height: 70px;
  }

  @media screen and (max-width: 640px) {
    height: 55px;
  }

  .active {
    background: #e5e5e5;
    box-shadow: inset -5px -5px 10px #ffffff;
    border: 0.10000000149011612px solid #ffffff03;
    outline: none;
    border-radius: 30px;
    text-shadow: inset 1px 1px 2px #00000029;

    > a {
      color: ${(props) => props.theme.color} !important;
    }
  }
`;

const SubMenu = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 90px;

  > a {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .font-menu {
    color: ${(props) => props.theme.color};
    font: 30px Kanit;
  }

  .active {
    border-bottom: ${(props) => props.theme.borderBottom};
    line-height: 50px;
  }

  @media screen and (max-width: 1200px) {
    height: 70px;

    .font-menu {
      font: normal normal normal 16px Kanit;
    }
  }

  @media screen and (max-width: 640px) {
    display: none;
  }
`;

const Button = css`
  display: flex;
  align-items: center;
  justify-content: space-around;
  text-transform: uppercase;
  font-weight: bold;
  width: 230px;
  height: 53px;
  color: #ffffff;
  user-select: none;
  position: relative;
  font-size: 24px;

  > img {
    width: 80px;
    height: 80px;
  }

  @media screen and (max-width: 1200px) {
    .font-top {
      font-size: 16px;
    }

    > img {
      width: 70px;
      height: 70px;
    }
    width: 180px;
    height: 40px;
  }

  @media screen and (max-width: 956px) {
    .font-top {
      font-size: 14px;
    }

    > img {
      width: 40px;
      height: 40px;
    }

    width: 155px;
    height: 40px;
  }

  @media screen and (max-width: 880px) {
    .font-top {
      font-size: 14px;
    }

    > img {
      width: 50px;
      height: 50px;
    }

    width: 120px;
    height: 40px;
  }

  @media screen and (max-width: 640px) {
    .font-top {
      font-size: 8px;
    }

    > img {
      width: 30px;
      height: 30px;
    }

    width: 70px;
    height: 20px;
  }
`;

const HeaderTheme = {
  live22: {
    background:
      "transparent linear-gradient(180deg, #0396ff 0%, #0080db 100%) 0% 0% no-repeat padding-box",
    color: "#0396ff",
  },
  slotxo: {
    background:
      "transparent linear-gradient(180deg, #E40203 0%, #960E10 100%) 0% 0% no-repeat padding-box",
    color: "#E40203",
  },
  pgslot: {
    background:
      "transparent linear-gradient(180deg, #28BC7B 0%, #3DB741 100%) 0% 0% no-repeat padding-box",
    color: "#28BC7B",
  },
  joker: {
    background:
      "transparent linear-gradient(180deg, #FF12A4 0%, #DA0055 100%) 0% 0% no-repeat padding-box",
    color: "#FF12A4",
  },
  ambslot: {
    background:
      "transparent linear-gradient(180deg, #FAEB57 0%, #E59801 100%) 0% 0% no-repeat padding-box",
    color: "#FFB503",
  },
};

const SubMenuTheme = {
  live22: {
    color: "#0396FF",
    borderBottom: "4px solid #0396FF",
  },
  slotxo: {
    color: "#E40203",
    borderBottom: "4px solid #E40203",
  },
  pgslot: {
    color: "#28BC7B",
    borderBottom: "4px solid #28BC7B",
  },
  joker: {
    color: "#FF12A4",
    borderBottom: "4px solid #FF12A4",
  },
  ambslot: {
    color: "#FFB503",
    borderBottom: "4px solid #FFB503",
  },
};

const Navbar = () => {
  const data = useStaticQuery(graphql`
    query NavbarInfo {
      datoCmsCommon {
        jokerLogo {
          url
        }
        live22Logo {
          url
        }
        pgslotLogo {
          url
        }
        slotxoLogo {
          url
        }
        ambslotLogo {
          url
        }
      },
      datoCmsMenu {
        menuItems {
          destination {
            title
            slug
            logoProvider {
              url
            }
          }
        }
      },
      datoCmsSubmenu {
        submenuItem {
          destination {
            slug
            title
            subpageName
          }
        }
      }
    }
  `)

  const { pathname } = useLocation();
  const currentPath = pathname;
  const [currentPage, setCurrentPage] = useState("live22");
  const [currentUrl, setCurrentUrl] = useState("");

  useMemo(() => {
    if (
      [
        "/",
        "/#anchorDownload",
        "/promotion",
        "/credit",
        "/contact",
        "/login",
        "/register",
        "/download/",
        "/promotion/",
        "/credit/",
        "/contact/",
        "/login/",
        "/register/",
      ].includes(currentPath)
    )
      setCurrentPage("live22");
    else setCurrentPage(currentPath.split("/")[1]);
  }, [currentPath]);

  useEffect(() => {
    if (
      ["anchorDownload", "promotion", "credit", "contact", "live22"].includes(
        currentPage
      )
    )
      setCurrentUrl("");
    else setCurrentUrl(currentPath.split("/")[1]);
  }, [currentPath]);

  return (
    <WrapperNavbar>
      <div className="mx-auto lg:container sm:container">
        <MenuList theme={HeaderTheme[currentPage]}>
          {data.datoCmsMenu.menuItems.filter(v => v.destination.slug.toLowerCase() !== 'ambslot').map((items, index) => (
            <div
              key={index}
              className={items.destination.title.toLowerCase() === currentPage ? "active" : ""}
            >
              <Link className={items.destination.title.toLowerCase()}
                to={`${items.destination.slug === "index" ? "/" : `/${items.destination.slug}`}`} css={Button}>
                <img src={items.destination.logoProvider.url} alt="" />
                <div className="font-top">{items.destination.title}</div>
              </Link>
            </div>
          ))}
        </MenuList>
        <SubMenu className="sm:hidden" theme={SubMenuTheme[currentPage]}>
          <Link to={`${currentUrl === "" ? "/" : `/${currentUrl}`}`} activeClassName="active">
            <div className="cursor-pointer font-menu">หน้าแรก</div>
          </Link>
          <Link to={`${currentUrl === "" ? "/#download" : `/${currentUrl}/#download`}`}>
            <div className="cursor-pointer font-menu">ดาวน์โหลด</div>
          </Link>
          {data.datoCmsSubmenu.submenuItem.map((items, index) => (
            <Link
              key={index}
              to={`${currentUrl === ""
                ? `/${items.destination.slug}`
                : `/${currentUrl}/${items.destination.slug}`
                }`}
              activeClassName="active"
            >
              <div className="cursor-pointer font-menu">{items.destination.subpageName}</div>
            </Link>
          ))}
        </SubMenu>
      </div>
    </WrapperNavbar>
  );
};

export default Navbar;
